import medicalAccountExplanationTemplate from 'views/modals/medical-account-explanation.html';

export class MedicalAccountExplanationComponent implements ng.IComponentOptions {
  public templateUrl: string;

  constructor() {
    this.templateUrl = medicalAccountExplanationTemplate;
  }
}
